import store from "@/store"

class Guest {
  constructor() {}
  async _init() {
    return true
  }

  get(property = null) {
    if (!store.state.guest) return null

    if (property) return store.state.guest[property]
    else return store.state.guest
  }
  welcome() {
    if (!_$.true(__.device.config("welcome.type"))) return true
    else if (["DS", "Public"].includes(__.device.get("using_by"))) return true
    else if (!this.get() && !sessionStorage.getItem("welcome")) return false
    else if (!this.get()) return true
    return _$.true(this.get("welcome"))
  }
  async update() {
    const guest = this.get()
    if (!guest) return false
    guest.language = store.getters.language.code

    return __.api.update.guest(guest)
  }
  async release() {
    store.commit("services/flush")

    const alarmClock = _$.store.getItem("services.alarm-clock")
    if (alarmClock) clearTimeout(alarmClock.timeout)

    _$.store.deleteItem("services")
    _$.store.deleteItem("guest")
    _$.store.deleteItem("guest_")
    return true
  }
  async check() {
    const hasGuest = _$.store.getItem("guest")
    if (hasGuest && !__.guest.get()) this.checkOut()
    else if (!hasGuest && __.guest.get()) this.checkIn()
    else if (hasGuest && __.guest.get() && `${__.guest.get("id") + __.guest.get("pms_id")}` !== hasGuest)
      this.checkOut(true).then(() => this.checkIn())

    return true
  }

  async checkIn() {
    _$.store.setItem("guest", `${__.guest.get("id") + __.guest.get("pms_id")}`)

    if (store.state.router && !__.guest.welcome()) __.platform.go("/welcome")

    if (__.device.config("checkin.poweron")) await __.device.powerOn()
    if (__._api?.checkIn) __._api.checkIn()

    return true
  }
  async checkOut(withCheckIn = false) {
    _$.nav.disable()

    await this.release()
      .then(() => __.device.clearData())
      .then(() => !withCheckIn && __.device.config("checkout.standby") && __.device.standBy())
      .finally(() => _$.nav.enable())

    if (__._api?.checkOut) __._api.checkOut()
  }

  //Channels Management
  addFavoriteChannel(channel) {
    let temp = _$.store.getItem("guest_.channels.favorites")
    if (!Array.isArray(temp)) temp = []
    channel.favorite = true

    if (temp.indexOf(channel.id) < 0) temp.push(channel.id)
    _$.store.setItem("guest_.channels.favorites", temp)
  }
  removeFavoriteChannel(channel) {
    let temp = _$.store.getItem("guest_.channels.favorites")
    if (!Array.isArray(temp)) temp = []
    channel.favorite = false

    temp = _$.removeFromArray(temp, channel.id)
    _$.store.setItem("guest_.channels.favorites", temp)
  }
  getFavoriteChannels() {
    return store.getters["live/allChannels"].filter(channel => channel.favorite)
  }
  hasFavoriteChannel() {
    return this.getFavoriteChannels().length ? true : false
  }
  isFavoriteChannel(id) {
    let temp = _$.store.getItem("guest_.channels.favorites")
    if (!Array.isArray(temp)) temp = []
    return temp.find(_id => _id === id) ? true : false
  }
}

export default new Guest()
